import React, { useContext } from "react";
import ClientListingTable from "./ClientListingTable";
import { LayoutContext } from "../../context/LayoutContext";
import ClientDashboardHeader from "./components/ClientDashboardHeader";

const Client = () => {
  const { isBannerVisible } = useContext(LayoutContext);

  return (
    <div
      className={`bg-[#F6F6F6] sm:fixed stikcy  2xl:w-[95.2%] xl:w-[93.2%] lg:w-[90.6%] md:w-[87.5%] sm:w-[95%] w-full h-screen transition-all ${
        isBannerVisible ? "top-[106px]" : "top-[56px]"
      }`}
    >
      <ClientDashboardHeader />
      <ClientListingTable />
    </div>
  );
};

export default Client;
